import base from "../middlewares/interceptors";
import {
  executeReRunResearchQueryURL,
  executeResearchQueryURL,
  backgroundExecuteResearchQueryURL,
  getResearchQueryRerunData as getResearchQueryRerunDataURL,
  backgroundExecuteResearchQueryReRunURL,
  getResearchQueryRerunParams,
} from "./constants";

export const executeResearchQueryById = async (
  researchQueryId: number,
  payload: any,
) => {
  try {
    const response = await base.post(
      `${executeResearchQueryURL}/${researchQueryId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const backgroundExecuteResearchQueryById = async (
  researchQueryId: number,
  payload: any,
) => {
  try {
    const response = await base.post(
      `${backgroundExecuteResearchQueryURL}/${researchQueryId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const backgroundExecuteResearchQueryReRun = async (payload: any) => {
  try {
    const response = await base.post(
      `${backgroundExecuteResearchQueryReRunURL}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const executeResearchQueryReRun = async (payload: any) => {
  try {
    const response = await base.post(
      `${executeReRunResearchQueryURL}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getResearchQueryRerunData = async (
  executionId: any
) => {
  // console.log("getResearchQueryRerunData", executionId, runId, runName);
  if (!executionId) {
    throw new Error("Research Query ID is required");
  }
  try {
    const url = `${getResearchQueryRerunParams}/${executionId}`;
    const response = await base.get(url);
    return response.data.execution_params;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};
